'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('./../');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Tooltip = exports.Tooltip = function Tooltip(_ref) {
  var _cn;

  var message = _ref.message,
      vPos = _ref.vPos,
      hPos = _ref.hPos,
      iconName = _ref.iconName,
      className = _ref.className;

  return _react2.default.createElement('span', { className: (0, _classnames2.default)('tlt-Wrapper', className) }, _react2.default.createElement(_.Icon, { name: iconName, className: 'tlt-Icon clr-Grey_300' }), _react2.default.createElement('span', {
    className: (0, _classnames2.default)('tlt-Dialog', (_cn = {}, (0, _defineProperty3.default)(_cn, 'tlt-Dialog-' + vPos, vPos), (0, _defineProperty3.default)(_cn, 'tlt-Dialog-' + hPos, hPos), _cn))
  }, _react2.default.createElement('span', { className: 'tlt-Message' }, message)));
};

Tooltip.defaultProps = {
  vPos: 'top',
  hPos: 'left',
  iconName: 'info-fill'
};

Tooltip.propTypes = {
  message: _propTypes2.default.string.isRequired,
  vPos: _propTypes2.default.oneOf(['top', 'bottom']),
  hPos: _propTypes2.default.oneOf(['left', 'center', 'right']),
  iconName: _propTypes2.default.string
};